var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',_vm._b({ref:"form",staticClass:"cr-form",attrs:{"model":_vm.model},nativeOn:{"submit":function($event){$event.preventDefault();}}},'el-form',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }